<!-- Decorative: the name is always printed beside it. -->
<span
    aria-hidden="true"
    class="inline-flex items-center justify-center rounded-full font-semibold leading-none select-none shrink-0 bg-surface-100 dark:bg-surface-800 border border-surface-300 dark:border-surface-600 text-surface-700 dark:text-surface-200"
    [class]="sizeClass()">
    @if (initials()) {
        {{ initials() }}
    } @else {
        <i class="pi pi-user !text-[1em] text-surface-500 dark:text-surface-400" aria-hidden="true"></i>
    }
</span>
